module.exports = __webpack_public_path__ + "img/appAsset-http--404-ax.14d4c18e.svg";